/* Arange Fragancia — reveal on scroll (progresivo, respeta reduced-motion via CSS).
   Additivo sobre Dawn; re-escanea en el editor de temas. */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.arange-reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', function () { reveal(); });
  // El editor de temas inserta/recarga secciones sin recargar la página:
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
